/**
 * Global override for PropertyBinding.sanitizeNodeName.
 *
 * The stock three.js sanitizer removes dots from node names, which
 * breaks bone-name conventions like "足.L" → "足L" (losing the side
 * separator).  This patch replaces dots with underscores instead
 * ("足.L" → "足_L"), preserving the separator in a form that's safe
 * for animation track parsing and matches common side patterns (_L/_R).
 *
 * Call once at app startup, before any loaders run.
 */

import { PropertyBinding } from 'three';

/** Same rules as patched PropertyBinding.sanitizeNodeName — use for loaders that set bone.name directly (e.g. BVH). */
export function sanitizeBindingNodeName(name: string): string {
  return name
    .replace(/\./g, '_')
    .replace(/\s/g, '_')
    .replace(/[[\]:]/g, '');
}

let patched = false;

export function patchSanitizeNodeName(): void {
  if (patched) return;
  patched = true;

  PropertyBinding.sanitizeNodeName = ((
    name: string,
  ): string => sanitizeBindingNodeName(name)) as typeof PropertyBinding.sanitizeNodeName;
}
